import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { LoginReq } from 'src/model/User/LoginReq';
import { LoginResp } from 'src/model/User/LoginResp';
import Cookies from 'js-cookie';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  account = '';
  password = '';
  errorMsg = '';
  showPassword = false;

  constructor(
    private userService: UserService,
    private router: Router
  ) {}
  // 按下登入按鈕時呼叫
  login() {
    this.errorMsg = '';
    const req: LoginReq = { username: this.account, password: this.password };
    this.userService.loign(req)
      .subscribe({
        next: (res: LoginResp) => {
          // 1. 存取 token 至 Session (自己使用)
          sessionStorage.setItem('jwt_token', res.access_token);
          // 2. 存取 token 至 Cookies (給它案網站使用)
          // Cookies.set('jwt_token', res.access_token, { expires: 1/24 });
          Cookies.set('jwt_token', res.access_token, { expires: 1/24 , domain: '.itri-nlp.tw'});
          // Cookies.set('jwt_token', res.access_token, {
          //   secure: true,            //  cookie 傳輸是否需要安全協定 (https)  Default = 無安全協定要求
          //   expires: 1/24          // 1小時
          // });
          // 3. 導向 Sync 頁面
          this.router.navigate(['/Sync']);
        },
        error: () => {
          this.errorMsg = '帳號或密碼錯誤，請重新輸入';
        }
      });
  }
  // 按下就是顯示密碼或者不顯示密碼切換
  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }
}
